export const lizenzAntraegeRugbyBundesliga2026 = {
  "id": "lizenz-antraege-rugby-bundesliga-2026",
  "title": "Lizenz-Anträge für Rugby-Bundesliga bis 1. Mai einreichen",
  "slug": "lizenz-antraege-rugby-bundesliga-2026",
  "publishedAt": "2026-04-22T09:00:00Z",
  "author": "Rugby-Bundesliga-Ausschuss",
  "language": "de",
  "readTime": "2 min",
  "tags": [
    "Rugby",
    "Bundesliga",
    "Lizenz",
    "Lizenzantrag",
    "RBA",
    "Saison 2025/26"
  ],
  "excerpt": "Der Rugby-Bundesligaausschuss bittet darum, die Lizenzanträge für die kommende Bundesligasaison der Herren fristgerecht bis zum 01.05.2025 um 23:59 Uhr einzureichen. Es sollten bitte nur Vereine Anträge einreichen, deren sportliche Qualifikation realistisch möglich ist.",
  "img": "/images/Lizenz--Antaege-Rugby-Bundesliga.png",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Der Rugby-Bundesligaausschuss bittet darum, die Lizenzanträge für die kommende Bundesligasaison der Herren fristgerecht bis zum 01.05.2025 um 23:59 Uhr einzureichen. Es sollten bitte nur Vereine Anträge einreichen, deren sportliche Qualifikation realistisch möglich ist."
    },
    {
      "type": "paragraph",
      "content": "Die Einreichung erfolgt online über folgenden Link:"
    },
    {
      "type": "list",
      "items": [
        { "content": "Online-Formular zur Lizenz-Einreichung", "url": "https://forms.gle/C2XkGbqq4dgRsTjP7" }
      ],
      "ordered": false
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Hinweise zur Einreichung"
    },
    {
      "type": "list",
      "items": [
        "Ein Antrag gilt jeweils für ein Team. Sollten mehrere Teams eines Vereins einen Antrag stellen, sind die erforderlichen Nachweise für jedes Team separat zu erbringen.",
        "Nachwuchs-Spielgemeinschaften (SGs) können höchstens für zwei Teams als Nachweis herangezogen werden. Wenn mehr als zwei Teams beteiligt sind, bitten wir euch, intern abzustimmen, welches Team den jeweiligen Nachweis einreicht. Ohne eindeutige Zuteilung gilt die Einreichung für diese Jugendteams als ungültig."
      ],
      "ordered": false
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Erforderliche Nachweise"
    },
    {
      "type": "paragraph",
      "content": "Eingereicht werden müssen Nachweise zu:"
    },
    {
      "type": "list",
      "items": [
        "Jugendmannschaften (U8–U18)",
        "einer Frauenmannschaft (1. Bundesliga)",
        "Trainer:innen inklusive Nachweis 50 % Anwesenheit in 2025/26",
        "Schiedsrichter:innen"
      ],
      "ordered": false
    },
    {
      "type": "paragraph",
      "content": "Zu beachten ist zudem, dass die sportliche Qualifikation noch nicht für alle Teams klar ist und man in diesem Fall den Antrag sowohl für die 1. und 2. Bundesliga markiert. Der RBA wird dann entsprechend der sportlichen Qualifikation werten."
    }
  ]
};
